import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  orderNumberFromModel,
  validateOrderNumberCondition,
  type OrderNumberState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_NUMBER = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderNumberState>>,
): ConditionType<OrderNumberState, ModelCondition.OrderNumber> => ({
  name: CONDITION_NAMES[ModelCondition.ORDER_NUMBER],
  description(state) {
    return t("Order numbers: {{numbers}}", { numbers: state.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<OrderNumberState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return orderNumberFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.ORDER_NUMBER, orderNumbers: state };
  },
  valid(state) {
    return validateOrderNumberCondition(state).valid;
  },
});
